import React, { Component } from "react";

const currency = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2
});

class NumberField extends Component {
    constructor(props) {
        super(props);

        this.focus = this.focus.bind(this);
        this.blur = this.blur.bind(this);
        this.formatOutput = this.formatOutput.bind(this);
        this.change = this.change.bind(this);
        this.init = this.init.bind(this);

        this.state = {
            focused: false,
            value: ''
        };
    }

    componentDidMount() {
        this.init(this.props);
    }

    componentWillReceiveProps(newProps) {
        this.init(newProps);
    }

    init(props) {
        const value = props.value !== '' ? props.value.toString().replace('.', ',') : '';

        this.setState({ value });
    }

    focus() {
        let value = this.state.value;

        /*
        if (value === '0')
            value = '';
        */
        value = '';

        this.setState({ value, focused: !this.props.readOnly });
    }

    blur() {
        let value = this.state.value;

        if(value !== '') {
            let number = parseFloat(value.replace(',', '.'));

            if(this.props.currency)
                number = number.toFixed(2);
            else
                number = number.toFixed(this.props.decimals);

            if (this.props.min !== undefined && number < this.props.min)
                number = this.props.min;
            else if (this.props.max !== undefined && number > this.props.max)
                number = this.props.max;

            value = number.toString().replace('.', ',');
        }
        else {
            if (this.props.min !== undefined) {
                const number = this.props.min;
                value = number.toString().replace('.', ',');
            }
        }

        this.setState({
            focused: false,
            value
        });

        value = value.replace(',', '.');

        if (this.props.change)
            this.props.change(value !== '' ? value : 0, this.props.name);
    }

    formatOutput(value) {
        let result = '';
        value = parseFloat(value.replace(',', '.'));

        if(!isNaN(value) && value.toFixed(2) - value.toFixed(0) === 0)
            value = parseInt(value);

        if(this.props.currency) {
            const curr = isNaN(value) ? currency.format(0) : currency.format(value);
            result = curr.toString().replace(',00', '');
        }
        else {
            result = value.toFixed(this.props.decimals).toString().replace('.', ',');
        }

        return result;
    }

    change(e) {
        const target = e.target;
        const value = target.value.replace('.', ',');

        if(this.state.focused)
            this.setState({ value });
    }

    render() {
        const { label, placeholder, change, name, className, inputId, inputClass, required, readOnly, currency, decimals, ...props } = this.props;

        return (
            <div className={`form-field input${className ? ` ${className}` : ''}${required ? ' required' : ''}${readOnly ? ' readonly' : ''}`} {...props}>
                {(label) ? <label htmlFor={inputId}>{label}</label> : null}

                <input id={inputId} className={inputClass ? `form-control ${inputClass}` : 'form-control'} required={required} readOnly={readOnly}
                       placeholder={placeholder} name={name} value={this.state.focused ? this.state.value : this.formatOutput(this.state.value)} onChange={this.change} onFocus={this.focus} onBlur={this.blur} />
            </div>
        );
    }
}

export default NumberField;